import { render, staticRenderFns } from "./FormCrearProveedor.vue?vue&type=template&id=61ef292c&scoped=true&"
import script from "./FormCrearProveedor.vue?vue&type=script&lang=ts&"
export * from "./FormCrearProveedor.vue?vue&type=script&lang=ts&"
import style0 from "./FormCrearProveedor.vue?vue&type=style&index=0&id=61ef292c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ef292c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('61ef292c', component.options)
    } else {
      api.reload('61ef292c', component.options)
    }
    module.hot.accept("./FormCrearProveedor.vue?vue&type=template&id=61ef292c&scoped=true&", function () {
      api.rerender('61ef292c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Proveedores/FormCrearProveedor.vue"
export default component.exports